export const memberApi = {
    list: {
        method: 'post',
        api: 'admin/members/list'
    },
    changeStatus: {
        method: 'post',
        api: 'admin/members/change_status'
    },
    getCompanyMemberList: {
        method: 'post',
        api: 'admin/members/get_company_member_list'
    },
    del: {
        method: 'post',
        api: 'admin/members/del'
    },
    createIncode: {
        method: 'post',
        api: 'admin/members/createIncode'
    },
  }